import { render, staticRenderFns } from "./HubControlForm.vue?vue&type=template&id=51d962e0&scoped=true&"
import script from "./HubControlForm.vue?vue&type=script&lang=js&"
export * from "./HubControlForm.vue?vue&type=script&lang=js&"
import style0 from "./HubControlForm.vue?vue&type=style&index=0&id=51d962e0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d962e0",
  null
  
)

export default component.exports